import { render, staticRenderFns } from "./draft_bank.vue?vue&type=template&id=d8999934&"
import script from "./draft_bank.vue?vue&type=script&lang=js&"
export * from "./draft_bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports